import React from "react";
import { observer } from "mobx-react";
import store from '../../../Stores/SurveyStore';
import SurveyCondensedTable from "../../../SurveyCondensedTable";
import { getOptionsArray, isUK } from "../../../../ibsHelper";
import ibsStore from '../../../Stores/IbsSurveyStore';
import { formDateReturnMonth } from "../../../../helpers";
import { SelectCombosIBS, NumberFormat } from "../../../../Enums/constants";
import { handleAssetAllocation } from "./AssetAllocationTableHandler";

const AssetAllocationTable = observer((props) => {
    return (
        <SurveyCondensedTable tableName={"AssetAllocation"}
            handleData={handleAssetAllocation}
            headers={["MainCategoryName", "SubCategoryName", "InternalPassiveMillions", "ExternalPassiveMillions", "Total", "RowID"]}
            columns={[
                { data: 'MainCategoryName', readOnly: true },
                { data: 'SubCategoryName', readOnly: true },
                { data: 'InternalPassiveMillions' },
                { data: 'ExternalPassiveMillions' },
                { data: 'Total', readOnly: true },
                { data: 'RowID' }
            ]}
            colWidths={['200px', '200px', '150px', '150px', '150px', ""]}
            calculationsProvided={[{ calColName: "Total", sums: ["InternalPassiveMillions", "ExternalPassiveMillions"] }]}
            hiddenColumns={[0]}
            formatting={['', '', NumberFormat.MONEYMILLION, NumberFormat.MONEYMILLION, NumberFormat.MONEYMILLION]}
            nestedHeaders={[
                ['Category', 'Employer securities', 'Internally managed<br/>($mils)', 'Externally managed<br/>($mils)', 'Total<br/>($mils)', ""]
            ]} />
    );

});
export default AssetAllocationTable;

